import { StripeTerminalError } from './StripeTerminalError';

export class StripeTerminalCollectPaymentError extends StripeTerminalError {
  constructor(message: unknown) {
    super(message);
    this.name = 'StripeTerminalCollectPaymentError';
  }
}
